import classNames from 'classnames';

import { SectionTitle } from '@/ui/index';

import styles from './TitleBlock.module.scss';

const TitleBlock = ({ data, className }) => {
  const renderCards = (item, index) => {
    return (
      <div
        className={styles['title-card']}
        data-testid='title-card'
        key={index}
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), url("${item?.image}")`,
        }}
      >
        <span className={styles['title-card__counter']}>{item?.title}</span>
        <div className={styles['title-card__content']}>
          {item?.text && (
            <SectionTitle
              titleModify={classNames([
                styles['title-card__title'],
                'title--medium',
              ])}
            >
              {item?.text}
            </SectionTitle>
          )}
          {item?.description && (
            <span className={styles['title-card__desc']}>
              {item?.description}
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <section className={classNames(styles['title-block'], className)}>
      {data?.title && (
        <SectionTitle
          className={styles['title-block__title']}
          titleModify='title--large'
          icon={data?.icon}
        >
          {data?.title}
        </SectionTitle>
      )}
      {data?.cards && (
        <div className={styles['title-block__inner']}>
          {data?.cards?.map(renderCards)}
        </div>
      )}
    </section>
  );
};

export default TitleBlock;
